import React from 'react';

export function BrandStory() {
  return (
    <section id="our-story" className="section brand-story-section">
      <div className="container">
        <div className="brand-story-grid">
          <div className="brand-story-visual">
            <div className="brand-story-photo-wrap">
              <img src="/Founder.webp" alt="Anchal with her daughter Kiana" className="brand-story-photo" loading="lazy" />
              <span className="brand-story-photo-badge">❝</span>
            </div>

            <div className="brand-story-stat-row">
              <div className="brand-story-stat stat-green">
                <span className="stat-number">100%</span>
                <span className="stat-label">Home-made</span>
              </div>
              <div className="brand-story-stat stat-coral">
                <span className="stat-number">0%</span>
                <span className="stat-label">Preservatives</span>
              </div>
              <div className="brand-story-stat stat-amber">
                <span className="stat-number">∞</span>
                <span className="stat-label">Love & Care</span>
              </div>
            </div>

            <div className="brand-story-quote-card">
              <p>Just a mother's recipe, made with a lot of love, for anyone who needs it.</p>
              <span className="signature-name">— Anchal</span>
              <span className="signature-title">Founder, Kiane</span>
            </div>
          </div>

          <div className="brand-story-content">
            {/* <div className="section-label">Our Story</div> */}
            <h2>Born on a Journey, Made with Love</h2>
            <div className="brand-story-heading-accent">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="brand-story-pull-quote">
              "I just wanted to feed my daughter something warm, healthy and real — wherever we were."
            </div>

            <div className="brand-story-text">
              <p>
                It started with a simple worry. I'm <strong>Anchal</strong>, a mother, and when my daughter
                <strong> Kiana</strong> was just two years old, I was travelling with her and found myself
                stuck with the same impossible question every parent knows — <em>what do I feed her?</em>
              </p>
              <p>
                Eating out felt unreliable, packaged snacks felt wrong, and nothing on the road felt good
                enough for her little tummy. So I did what mothers do — I figured it out. I prepared a
                homemade mix before leaving, packed it in my bag, and all I needed at the hotel was a cup
                of hot water. In minutes, Kiana had a warm, nourishing bowl she actually loved.
              </p>
              <p>
                That trip changed everything. I realised this wasn't just my problem. It was the problem of
                every parent travelling with young children, every office-goer who skips breakfast because
                mornings are chaos, every busy person who wants to eat healthy but doesn't have the time.
              </p>
              <p>
                So I started making it for others. Every packet of <strong>Kiane</strong> — named after my
                daughter — is still prepared at home, with the same care I put into that very first bowl.
                No preservatives. No refined sugar. No shortcuts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
